<!--Main Table-->
<div>
	<h4 class="CenterHeading">Passes:</h4>

	<caass-ms-history-main-table [lstVisitorPass]="lstVisitorPass" [loading]="LoadingPasses" (VisitorPassSelected)="onVisitorPassSelected($event)">
	</caass-ms-history-main-table>
</div>

<div class="hr-line-dashed ItemBorder"></div>

<!--Pass Scans-->
<div *ngIf="lstScans.length > 0">
	<h4 class="CenterHeading">Scans with Selected Pass</h4>

	<caass-ms-history-details-table [lstVisitorPassDetail]="lstScans" [loading]="LoadingScans"> </caass-ms-history-details-table>
</div>

<div *ngIf="lstScans.length > 0" class="hr-line-dashed ItemBorder"></div>

<!--Selected Pass Images-->
<div *ngIf="PassImage_PNG != '' || VisitorSignature != ''">
	<h4 *ngIf="PassImage_PNG != ''" class="CenterHeading">Pass:</h4>
	<div *ngIf="PassImage_PNG != ''" class="PhotoDiv">
		<img class="VisitorPhoto" [src]="PassImage_PNG" />
	</div>

	<h4 *ngIf="VisitorSignature != ''" class="CenterHeading">Signature:</h4>
	<div *ngIf="VisitorSignature != ''" class="PhotoDiv">
		<img class="VisitorPhoto" [src]="VisitorSignature" />
	</div>
</div>

<div *ngIf="PassImage_PNG != '' || VisitorSignature != ''" class="hr-line-dashed ItemBorder"></div>
